<template>
  <div class="container">
    <div class="checking-information">
      <div class="information-title">
        <span>巡检评价</span>
      </div>
      <div class="information-content">
        <div class="information-list">
          <span>巡检位置：</span>
          <span>{{detailsList.content}}</span>
        </div>

        <div class="information-list">
          <span>申请时间：</span>
          <span>{{detailsList.inspectionDate}}</span>
        </div>
        <div class="information-list">
          <span>巡检人：</span>
          <span>{{detailsList.userName}}</span>
        </div>
        <div class="information-list">
          <span>网吧：</span>
          <span>{{detailsList.siteName}}</span>
        </div>
        <div class="information-list">
          <span>联系人：</span>
          <span>{{detailsList.name}}</span>
        </div>
        <div class="information-list">
          <span>联系电话：</span>
          <span>{{detailsList.phone}}</span>
        </div>
        <div class="information-list">
          <span class="situation">巡检情况：</span>
          <span class="situation-content">{{detailsList.description}}</span>
        </div>
        <div class="information-list">
            
          <span class="situation-img">上传图片：</span>
           <span class="situation-content">
            <img
              v-for="(item,index) in pictureList"
              :key="index"
              :src="item.url"
              alt
              srcset
              @click="HandleclickImg(index)"
            />
          </span>
        </div>
      </div>
    </div>
    <div class="block"></div>
    <!-- 评价 -->
    <div style="background-color:#ffffff">
      <div class="evaluation">
        <span>描述相符</span>
        <van-rate v-model="value" readonly v-if="isEvaluate == 1"/>
         <van-rate v-model="value" v-if="isEvaluate == 0"/>
      </div>
      <div class="textarea">
         <textarea v-reset-page  name id cols="30" rows="10" placeholder="请输入想要的内容" :value="content" disabled v-if="isEvaluate == 1"></textarea>
        <textarea v-reset-page  name id cols="30" rows="10" placeholder="请输入想要的内容" v-model="content" v-if="isEvaluate == 0"></textarea>
      </div>
    </div>
    <div class="btn" @click="handleSaveClick" v-if="isEvaluate == 0">评价</div>
  </div>
</template>

<script>
import { Rate } from "vant";
import { Evaluate } from "@/api/public"
import { inspectionDetails } from "@/api/inspection";
import { ImagePreview } from "vant";
import { Toast } from "vant"
import wx from "weixin-js-sdk";
export default {
  components: {
    vanRate: Rate
  },
  data() {
    return {
      value: 0,
      content:'',
      detailsList:[],
      pictureList:[],
      ImagePreview:[],
      isEvaluate:''
    };
  },
  mounted() {
      this.requestInspectionDetails()
  },
  methods:{
      requestEvaluate() {
          let content = this.content
          let value = this.value
          let formIdOrWorkId = this.$utils.getUrlKey('inspectionWorkId')
          if(!JSON.stringify(value)) {
               Toast('请选择星级')
               return false
           }
           if(!content) {
               Toast("请输入评价")
               return false
           }
           Evaluate({content:content,grade:value,type:1,formIdOrWorkId:formIdOrWorkId}).then(res=>{
               console.log(res)
               if(res.code == 200) {
                 wx.closeWindow()
               }
           })
      },
    //  巡检详情
        requestInspectionDetails() {
         let formIdOrWorkId =  this.$utils.getUrlKey('inspectionWorkId')
          inspectionDetails({id:formIdOrWorkId}).then(res=>{
              console.log(res)
              this.detailsList = res.data
              this.pictureList = res.data.pictureList
              this.value = res.data.grade
              this.content = res.data.evaluateContent
              this.isEvaluate = res.data.isEvaluate
              res.data.pictureList.forEach(element => {
                  console.log(element)
                  this.ImagePreview.push(element.url)
              });

          })
      },
    //   查看大图
           HandleclickImg(index) {
          ImagePreview({
            images:this.ImagePreview,
            startPosition: index,
          } 
        );
      },
    // 点击保存
    handleSaveClick() {
        this.requestEvaluate()
    }
  }
};
</script>

<style scoped lang="scss">
.container {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  overflow-x: hidden;
  .checking-information {
    background-color: #ffffff;
    font-size: 15px;
    text-align: left;
    padding: 0 13px;
    box-sizing: border-box;
    .information-title {
      width: 100%;
      height: 54px;
      line-height: 50px;
      border-bottom: 2px solid #f9f9f9;
      text-align: left;
      color: #333333;
      overflow: hidden;
    }
    .information-content {
      padding: 10px 0;
      box-sizing: border-box;
      .information-list {
        //    height: 40px;
        //    line-height: 40px;
        margin-top: 20px;
        .situation-img {
          float: left;
        //   height: 20px;;
        //   margin-top: 20px;
        }
        .situation-content {
          display: inline-block;
          width: 78%;
          img {
            vertical-align: top;
            width: 60px;
            height: 60px;
          }
        }
      }
    }
  }
  .block {
    width: 100%;
    height: 10px;
    background-color: #f6f6f6;
  }
  .evaluation {
    width: 100%;
    height: 54px;
    line-height: 50px;
    padding: 0 13px;
    box-sizing: border-box;
    border-bottom: 2px solid #f9f9f9;
    text-align: left;
    color: #333333;
    font-size: 15px;
    overflow: hidden;
    span {
      margin-right: 10px;
      vertical-align: middle;
    }
  }
  .textarea {
    width: 100%;
    height: 180px;
    padding: 14px 13px;
    box-sizing: border-box;
    textarea {
      width: 100%;
      height: 100%;
      border: none;
      font-size: 14px;
      color: #999999;
      &::-webkit-input-placeholder {
        color: #999999;
        font-size: 14px;
      }
      &:disabled {
         background-color: #ffffff
      }
    }
  }
  .btn {
    width: 350px;
    height: 44px;
    background: -webkit-linear-gradient(left, #05aefc, #008cff);
    border-radius: 22px;
    font-size: 16px;
    color: $white-color;
    line-height: 44px;
    margin: 40px auto;
  }
}
</style>
<style lang="scss">
.van-rate {
  vertical-align: middle;
}
</style>
